module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card"
  }, [_c('v-toolbar', {
    staticClass: "homepage-tool elevation-0 black--text",
    attrs: {
      "color": "white"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('h5', {
    staticClass: "pt-3 pb-3 pl-4 pr-4",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v("Web Analytics")])]), _vm._v(" "), _c('v-tabs', {
    staticClass: "my_white",
    attrs: {
      "fixed": "",
      "color": "white"
    }
  }, _vm._l((_vm.menuItems), function(item, i) {
    return _c('v-tab', {
      key: i,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.changeMetrics(item.value)
        }
      }
    }, [_vm._v("\n          " + _vm._s(item.title) + "\n        ")])
  }), 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": 50,
      "color": "primary"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    staticClass: "custom-toolbar pa-4 pt-3",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-menu', {
    staticClass: "bordered-menu",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuEnd),
      callback: function($$v) {
        _vm.menuEnd = $$v
      },
      expression: "menuEnd"
    }
  }, [_c('v-text-field', {
    staticClass: "datepic",
    attrs: {
      "slot": "activator",
      "label": "End Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1), _vm._v(" "), _c('v-menu', {
    staticClass: "bordered-menu",
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menuStart),
      callback: function($$v) {
        _vm.menuStart = $$v
      },
      expression: "menuStart"
    }
  }, [_c('v-text-field', {
    staticClass: "datepic",
    attrs: {
      "slot": "activator",
      "label": "Start Date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1), _vm._v(" "), _c('v-select', {
    staticClass: "datepic select_pic",
    attrs: {
      "items": _vm.selectItems,
      "item-text": "title",
      "item-value": "value",
      "label": "Select",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.changeMetricsx
    },
    model: {
      value: (_vm.graphtype),
      callback: function($$v) {
        _vm.graphtype = $$v
      },
      expression: "graphtype"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('vue-highcharts', {
    ref: "area",
    attrs: {
      "options": _vm.chart
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticStyle: {
      "padding-right": "5px"
    },
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('p', {
    staticClass: "page_head center",
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_vm._v("Page Views by Location")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "350px",
      "border": "0",
      "width": "100%"
    },
    attrs: {
      "id": "map"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding-left": "5px"
    },
    attrs: {
      "xs12": "",
      "sm6": "",
      "pa-4": ""
    }
  }, [_c('p', {
    staticClass: "page_head center",
    style: ({
      color: _vm.styles.general.theme_color_light
    })
  }, [_vm._v("Page Views by Page")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, _vm._l((_vm.toppages), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "tab1"
    }, [_vm._v(_vm._s(item[0]))]), _vm._v(" "), _c('td', [_c('Progressd', {
      staticClass: "mb-2",
      attrs: {
        "value": item[2]
      }
    }), _vm._v(" "), _c('span', [_vm._v("   " + _vm._s(_vm._f("formatNumber")(item[1])) + "(" + _vm._s(item[2]) + "%)")])], 1)])
  }), 0)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c39872","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/chart.vue
// module id = 1636
// module chunks = 0